module.exports = __webpack_public_path__ + "static/media/olhsLogo.efb3f575.png";